<template>
  <div>
    <app-header />

    <div
      class="
        uk-section uk-padding-remove-vertical uk-margin-remove-vertical
        in-equity-breadcrumb
      "
    >
      <div class="uk-container">
        <div class="uk-grid">
          <div class="uk-width-1-1">
            <ul class="uk-breadcrumb">
              <li>
                <router-link :to="{ name: 'public.home' }">Home</router-link>
              </li>
              <li><span>Recover Account</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="
        uk-section uk-section-muted uk-flex uk-flex-middle uk-animation-fade
      "
      style="padding-top; 0"
      uk-height-viewport
    >
      <div class="uk-width-1-1" style="margin-top: -100px">
        <div class="uk-container">
          <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
            <div class="uk-width-1-1@m">
              <div
                class="
                  uk-margin
                  uk-width-large
                  uk-margin-auto
                  uk-card
                  uk-card-default
                  uk-card-body
                  uk-box-shadow-large
                "
              >
                <h2>Failed!</h2>
                <p>Invalid Token. Contact us for further assistance</p>
                <p class="text-center">
                  <router-link :to="{ name: 'public.home' }" class="uk-button uk-button-primary uk-button-large uk-width-1-1"><i class="fa fa-home"></i> Okay</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer />
  </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  components: {
    AppHeader,
    AppFooter,
  },

  mounted() {
    this.fetch()
  },

  data() {
    return {
      
    };
  },

  methods: {
    fetch() {
      this.$loader.start('full')

      this.$axios.post(`/api/v1/activate-account`, { code: this.$route.params.code }).then(response => {
        if(response.data.success) {
          this.$auth.setToken(response.data.access_token);
          window.location.href = this.$router.resolve({
            name: "redirect",
          }).href;
        } else {
          this.$loader.stop()
        }
      })
    }
  },
};
</script>
